import { DownloadFileData } from '@keaze/web/components/downloadFile';
import {
  sitePlanImages,
  Brochure,
  FloorPlan,
  PropertyDetails,
} from '@keaze/web/common/interfaces';
import { PlanModalData } from '../../planModal';
import { SpecificationsData } from '../../specifications/specifications.types';

type Slide = {
  src: string;
  alt: string;
};

type ConvertFloorPlansToImages = (floorplans: FloorPlan[]) => Slide[];

type ConvertPropertiesToPlans = (
  propertiesForListing: PropertyDetails[]
) => PlanModalData[];

type ConvertBrochuresToDownloadFiles = (
  brochures: Brochure[] | null
) => DownloadFileData[];

type ConvertSiteplanToDownloadFiles = (
  sitePlanImages: sitePlanImages[] | null
) => DownloadFileData[];

type ConvertFloorPlansToSpecifications = (
  floorPlans: FloorPlan[]
) => SpecificationsData[];

type ConvertFloorPlansToPlans = (
  specifications: FloorPlan[] | null,
  customFullSpecifications: string | null
) => PlanModalData[];

export const convertFloorPlansToSpecifications: ConvertFloorPlansToSpecifications =
  (floorPlans) =>
    floorPlans.map(({ id, thumbnailUrl }) => ({ id, image: thumbnailUrl }));

const convertFloorPlansToImages: ConvertFloorPlansToImages = (floorplans) => {
  if (!floorplans) {
    return [];
  }

  return floorplans.map(({ url, alternativeText, caption }) => ({
    src: url,
    alt: caption ?? alternativeText,
  }));
};

export const convertPropertiesToPlans: ConvertPropertiesToPlans = (
  propertiesForListing
) =>
  propertiesForListing.map(({ id, floorplans, fullSpecifications }) => ({
    id,
    images: convertFloorPlansToImages(floorplans),
    specification: fullSpecifications,
  }));

export const convertFloorPlansToPlans: ConvertFloorPlansToPlans = (
  floorPlans,
  customFullSpecifications
) => {
  if (floorPlans === null) {
    return [];
  }

  return floorPlans.map(({ id, alternativeText, caption, url }) => ({
    id,
    images: [
      {
        src: url,
        alt: caption ?? alternativeText,
      },
    ],
    specification: customFullSpecifications,
  }));
};

export const convertBrochuresToDownloadFiles: ConvertBrochuresToDownloadFiles =
  (brochures) => {
    if (brochures === null) {
      return [];
    }

    return brochures.map(({ caption, url }) => ({ title: caption, link: url }));
  };

export const convertSiteplanToDownloadFiles: ConvertSiteplanToDownloadFiles = (
  sitePlanImages
) => {
  if (sitePlanImages === null) {
    return [];
  }

  return sitePlanImages.map(({ caption, url }) => ({
    title: caption,
    link: url,
  }));
};
